import axios from 'axios'
import * as types from '../mutation-types'

// namespaced
export const namespaced = true

// state
export const state = {
  msg: null,
  receipts: []
}

// getters
export const getters = {
  receiptMsg: state => state.msg,
  receipts: state => state.receipts
}

// mutations
export const mutations = {
  [types.RESET_RECEIPT_DATA] (state) {
    Object.assign(state, {
      msg: null,
      receipts: []
    })
  },

  [types.SET_RECEIPT_MSG] (state, msg) {
    const msgs = {
      receipt: 'Failed to fetch receipt data',
      receipt2: 'Failed to save receipt data',
      receipts: 'Failed to fetch receipts',
      email2: 'email_receipt_fail_notice'
    }
    const message = msg ? (msgs[msg] ? msgs[msg] : msg) : 'Failed to fetch data'
    state.msg = message
  },

  [types.RESET_RECEIPT_MSG] (state) {
    state.msg = null
  },

  [types.FETCH_RECEIPTS] (state, { receipts }) {
    state.receipts = receipts
  },

  [types.ADD_RECEIPT] (state, payload) {
    // payload is receipt
    const i = state.receipts.findIndex(o => parseInt(o.id) === parseInt(payload.id))
    if (i === -1) { // only add new receipt
      state.receipts.unshift(payload)
    }
  }
}

// actions
export const actions = {
  resetReceiptData ({ commit }) {
    commit(types.RESET_RECEIPT_DATA)
  },

  async fetchReceipts ({ commit, rootGetters }) {
    commit(types.RESET_RECEIPT_MSG)
    try {
      const { data } = await axios.post('/api/receipts', {
        restaurant_id: parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid']),
        loyalty_group_id: parseInt(rootGetters['config/loyaltyGroupId'])
      })
      // data is { receipts }
      commit(types.FETCH_RECEIPTS, data)
    } catch (e) {
      commit(types.SET_RECEIPT_MSG, 'receipts')
    }
  },

  async sendMail ({ commit, rootGetters }, payload) {
    commit(types.RESET_RECEIPT_MSG)
    try {
      let recipientName, recipientEmail, recipientContact
      let countryCode, phoneNumber, receiver, receiverContact
      if (rootGetters['member/isMember']) {
        const user = rootGetters['auth/user']
        recipientName = user.name
        recipientEmail = user.email
        recipientContact = '+ ' + user.country_code + ' ' + user.mobile
        receiver = (rootGetters['member/isMember']) ? rootGetters['delivery/address'].contact_name : ''
        receiverContact = (rootGetters['member/isMember']) ? rootGetters['delivery/address'].contact_no : ''
      } else {
        // recipientName = rootGetters['config/guestName']
        // recipientEmail = 'erica.yap@aptsys.com.sg'
        const guest = rootGetters['cart/guestDetails']
        recipientName = rootGetters['config/guestName']
        recipientEmail = guest.email ? guest.email : 'junye.teo@aptsys.com.sg'
        countryCode = guest.country_code ? guest.country_code : '65'
        phoneNumber = guest.mobile ? guest.mobile : '88888888'
        receiver = rootGetters['config/guestName']
        recipientContact = '+ ' + countryCode + ' ' + phoneNumber
        receiverContact = '+ ' + countryCode + ' ' + phoneNumber
      }
      const { data } = await axios.post('/api/email/receipt', {
        receiptHeader: rootGetters['config/gemsSetting'].Header ? rootGetters['config/gemsSetting'].Header : '',
        storeName: rootGetters['config/config'].full_name,
        recipientName: recipientName,
        recipientEmail: recipientEmail,
        recipientContact: recipientContact,
        receiver: receiver,
        receiver_contact: receiverContact,
        receiptBcc: rootGetters['config/config'].email_order_bcc,
        remarks: rootGetters['cart/remarks'] ? rootGetters['cart/remarks'] : '',
        helpFooter: rootGetters['config/config'].email_help_footer,
        receipt: payload
      })
      if (data !== 1) {
        commit(types.SET_RECEIPT_MSG, 'email2')
      }
    } catch (e) {
      commit(types.SET_RECEIPT_MSG, 'email2')
    }
  },

  addReceipt ({ commit }, payload) {
    commit(types.ADD_RECEIPT, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/receipt.js